import { atom } from 'recoil';

export const notesStatusAtom = atom({
  key: 'notesStatusAtom',
  default: 0,
});
